<template>
  <transition name="pop-in">
    <div class="bxp-back-to-top" @click="backToTop()" v-if="show">
      <v-icon>fa-chevron-up</v-icon>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    backToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.show = window.scrollY >= 800
    })
  }
}
</script>

<style>
  .bxp-back-to-top {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50px;
    background: rgba(0,0,0,0.15);
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 99999;
  }
  .bxp-back-to-top:hover {
    cursor: pointer !important;
  }

  .bxp-back-to-top i:before {
    font-size: 12px;
    color: white;
  }
  
</style>